import Component from './direct_message_dialog.vue'
export default Component
